"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var immutable_1 = require("immutable");
var ReadingContext = /** @class */ (function () {
    function ReadingContext(fieldProvider) {
        this.fieldProvider = fieldProvider;
        this._currentPath = immutable_1.List().asMutable();
    }
    Object.defineProperty(ReadingContext.prototype, "currentPath", {
        get: function () {
            return this._currentPath.asImmutable();
        },
        enumerable: true,
        configurable: true
    });
    ReadingContext.prototype.addToPath = function (node) {
        this._currentPath.push(node);
    };
    return ReadingContext;
}());
exports.ReadingContext = ReadingContext;
//# sourceMappingURL=reading-context.js.map